export default __webpack_public_path__ + "static/media/audiobook.43797075.svg";